import React, { useState, useEffect, useRef, useCallback } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./index.less";
import BaseSwiper from "../../components/BaseSwiper";
import { adaptSize } from '../../utils/remAdapter'
import { useHashAnchor } from '../../hooks/useHashAnchor';

// 导入banner图片
import smartTravelBanner from "../../assets/newVersion/screen_bg.avif";
import banner1 from '../../assets/banners/smart-travel/intelligent-cockpit1.avif'
import banner1Little from '../../assets/banners/smart-travel/intelligent-cockpit1-little.avif'
import banner2 from '../../assets/banners/smart-travel/intelligent-cockpit2.avif'
import banner2Little from '../../assets/banners/smart-travel/intelligent-cockpit2-little.avif'
import banner3 from '../../assets/banners/smart-travel/intelligent-cockpit3.avif'
import banner3Little from '../../assets/banners/smart-travel/intelligent-cockpit3-little.avif'
import banner4 from '../../assets/banners/smart-travel/intelligent-cockpit4.avif'
import banner4Little from '../../assets/banners/smart-travel/intelligent-cockpit4-little.avif'
import banner5 from '../../assets/banners/smart-travel/intelligent-cockpit5.avif'
import banner5Little from '../../assets/banners/smart-travel/intelligent-cockpit5-little.avif'
import banner6 from '../../assets/banners/smart-travel/intelligent-cockpit6.avif'
import banner6Little from '../../assets/banners/smart-travel/intelligent-cockpit6-little.avif'
// 第一屏图片
import mouse from '../../assets/newVersion/mouse.svg';
// 第二屏图片
import intelligentCockpit from '../../assets/newVersion/intelligent-cockpit.svg';
// 三屏图片
import screen31 from '../../assets/newVersion/screen-3-banner.avif'
import screen32 from '../../assets/newVersion/screen-3-2-banner.avif'
// 四屏图片
import bottomBorder from '../../assets/newVersion/border-bottom.svg'
// 五屏图片
import xiaopeng from '../../assets/newVersion/merchant/xiaopeng.png';
import bmw from '../../assets/newVersion/merchant/bmw.png';
import jili from '../../assets/newVersion/merchant/jili.png';
import seres from '../../assets/newVersion/merchant/seres.png';
import changan from '../../assets/newVersion/merchant/changan.png';
import hongqi from '../../assets/newVersion/merchant/hongqi.png';
import chelingkeji from '../../assets/newVersion/merchant/chelingkeji.png';
import beidouzhilian from '../../assets/newVersion/merchant/beidouzhilian.png';
import lanjingzhilian from '../../assets/newVersion/merchant/lanjingzhilian.png';
import fute from '../../assets/newVersion/merchant/fute.png';
import lantu from '../../assets/newVersion/merchant/lantu.png';
import yuchuang from '../../assets/newVersion/merchant/yuchuang.png';
import neusoft from '../../assets/newVersion/merchant/neusoft.png';
import haishuikeji from '../../assets/newVersion/merchant/haishuikeji.png';
import yiqi from '../../assets/newVersion/merchant/yiqi.png';
import shangqidatong from '../../assets/newVersion/merchant/shangqidatong.png';
import shangqidazhong from '../../assets/newVersion/merchant/shangqidazhong.png';
import _212 from '../../assets/newVersion/merchant/212.png';
import JMC from '../../assets/newVersion/merchant/JMC.png';
import dongfengqiche from '../../assets/newVersion/merchant/dongfengqiche.png';
import kaiyiqiche from '../../assets/newVersion/merchant/kaiyiqiche.png';

gsap.registerPlugin(ScrollTrigger)

// 大小图映射
const bannerSrcMap: { full: string; little: string }[] = [
  { full: banner1, little: banner1Little },
  { full: banner2, little: banner2Little },
  { full: banner3, little: banner3Little },
  { full: banner4, little: banner4Little },
  { full: banner5, little: banner5Little },
  { full: banner6, little: banner6Little },
];

// 阈值：宽度小于此值用缩略图，大于此值用大图
const THUMB_THRESHOLD = adaptSize(240) as number;

// 合作伙伴数据抽取
const merchantsData = [
  { src: xiaopeng, alt: "小鹏汽车", className: "xiaopeng" },
  { src: bmw, alt: "宝马", className: "bmw" },
  { src: jili, alt: "吉利汽车", className: "jili" },
  { src: seres, alt: "seres", className: "seres" },
  { src: lantu, alt: "海冰科技", className: "lantu" },
  { src: changan, alt: "长安汽车", className: "changan" },
  { src: hongqi, alt: "红旗汽车", className: "hongqi" },
  { src: JMC, alt: "JMC", className: "JMC" },
  { src: fute, alt: "福特", className: "fute" },
  { src: shangqidazhong, alt: "上汽大众", className: "shangqidazhong" },
  { src: dongfengqiche, alt: "东风汽车", className: "dongfengqiche" },
  { src: yiqi, alt: "一汽", className: "yiqi" },
  { src: kaiyiqiche, alt: "凯翼汽车", className: "kaiyiqiche" },
  { src: shangqidatong, alt: "上汽大通", className: "shangqidatong" },
  { src: yuchuang, alt: "鱼创", className: "yuchuang" },
  { src: neusoft, alt: "NeuSoft", className: "neusoft" },
  { src: chelingkeji, alt: "车铃", className: "chelingkeji" },
  { src: haishuikeji, alt: "海冰科技", className: "haishuikeji" },
  { src: _212, alt: "212", className: "_212" },
  { src: beidouzhilian, alt: "北斗智联", className: "beidouzhilian" },
  { src: lanjingzhilian, alt: "蓝鲸智联", className: "lanjingzhilian" },
];

// 分割数据为两行（前10个，后11个）
const row1Merchants = merchantsData.slice(0, 10);
const row2Merchants = merchantsData.slice(10);

const SmartTravel: React.FC = () => {

  useHashAnchor();
  const containerRef = useRef<HTMLDivElement>(null);
  const secondSectionRef = useRef<HTMLDivElement>(null);
  const secondImgTitleRef = useRef<HTMLImageElement>(null);
  const bannerRef = useRef<HTMLDivElement>(null);
  const leftRef = useRef<HTMLDivElement>(null);
  const rightRef = useRef<HTMLDivElement>(null);
  const right2Ref = useRef<HTMLDivElement>(null);
  const right3Ref = useRef<HTMLDivElement>(null);
  const bannerImg1Ref = useRef<HTMLImageElement>(null);
  const bannerImg2Ref = useRef<HTMLImageElement>(null);
  const bannerImg3Ref = useRef<HTMLImageElement>(null);
  const bannerImg4Ref = useRef<HTMLImageElement>(null);
  const bannerImg5Ref = useRef<HTMLImageElement>(null);
  const bannerImg6Ref = useRef<HTMLImageElement>(null);

  const thirdSectionRef = useRef<HTMLDivElement>(null);
  const thirdTitleRef = useRef<HTMLDivElement>(null);
  const thirdMsgRef = useRef<HTMLDivElement>(null);
  const screen31Ref = useRef<HTMLDivElement>(null);
  const screen32Ref = useRef<HTMLDivElement>(null);
  const screen31TitleRef = useRef<HTMLDivElement>(null);
  const screen31MsgRef = useRef<HTMLDivElement>(null);
  const screen32TitleRef = useRef<HTMLDivElement>(null);
  const screen32MsgRef = useRef<HTMLDivElement>(null);

  const fourthSectionRef = useRef<HTMLDivElement>(null);
  const rightItemsRef = useRef<(HTMLDivElement | null)[]>([]);

  const fifthSectionRef = useRef<HTMLDivElement>(null);

  // 跟踪每张图当前用的是大图还是小图
  const imgSrcStateRef = useRef<('full' | 'little')[]>(['little', 'little', 'little', 'little', 'little', 'little']);

  const getAllBannerImgRefs = useCallback(() => [
    bannerImg1Ref,
    bannerImg2Ref,
    bannerImg3Ref,
    bannerImg4Ref,
    bannerImg5Ref,
    bannerImg6Ref,
  ], []);

  // 根据当前宽度切换大小图src
  const updateBannerSrc = useCallback((imgEl: HTMLImageElement | null, index: number) => {
    if (!imgEl) return;
    const currentWidth = gsap.getProperty(imgEl, "width") as number;
    const opacity = gsap.getProperty(imgEl, "opacity") as number;

    if ((currentWidth < THUMB_THRESHOLD || opacity < 0.55) && imgSrcStateRef.current[index] === 'full') {
      imgEl.src = bannerSrcMap[index].little;
      imgSrcStateRef.current[index] = 'little';
    } else if (currentWidth >= THUMB_THRESHOLD && opacity >= 0.55 && imgSrcStateRef.current[index] === 'little') {
      imgEl.src = bannerSrcMap[index].full;
      imgSrcStateRef.current[index] = 'full';
    }
  }, []);

  useEffect(() => {
    const allRefs = getAllBannerImgRefs();

    // 用 ticker 每帧检测所有 banner 图片尺寸，切换大小图
    const onTick = () => {
      allRefs.forEach((ref, i) => updateBannerSrc(ref.current, i));
    };
    gsap.ticker.add(onTick);

    const ctx = gsap.context(() => {
      // ==================== 初始化状态 ====================
      gsap.set(secondImgTitleRef.current, {
        y: adaptSize(32),
        left: '50%',
        x: '-50%',
        width: adaptSize(740),
        height: adaptSize(77),
        opacity: 1,
        force3D: true,
      });

      gsap.set(bannerRef.current, {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        force3D: true,
      });

      gsap.set(leftRef.current, { opacity: 0, force3D: true });

      // 所有右侧文字初始都隐藏
      gsap.set([rightRef.current, right2Ref.current, right3Ref.current], {
        opacity: 0, force3D: true
      });

      gsap.set(bannerImg1Ref.current, {
        opacity: 1,
        width: adaptSize(8),
        height: adaptSize(8),
        left: '50%',
        x: '-50%',
        top: adaptSize(128),
        force3D: true,
      });

      gsap.set([bannerImg3Ref.current, bannerImg4Ref.current, bannerImg5Ref.current, bannerImg6Ref.current], {
        opacity: 0,
        width: adaptSize(8),
        height: adaptSize(8),
        force3D: true,
      });

      gsap.set(bannerImg2Ref.current, {
        left: adaptSize(0),
        top: adaptSize(0),
        width: adaptSize(880),
        height: adaptSize(880),
        opacity: 0,
        force3D: true,
      });

      // ==================== 首屏到二屏过渡 ====================
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: bannerRef.current,
          start: "top top",
          end: "+=100%",
          scrub: 0.8,
        },
      });

      tl.to(bannerRef.current, {
        borderBottomLeftRadius: adaptSize(160),
        borderBottomRightRadius: adaptSize(160),
        duration: 0.33,
        opacity: 1,
        ease: "none",
      }, 0);

      tl.to(secondImgTitleRef.current, {
        y: adaptSize(23),
        width: adaptSize(1930),
        height: adaptSize(200),
        left: '50%',
        x: '-50%',
        opacity: 0.06,
        duration: 0.6,
        ease: "none",
      }, 0);

      tl.to(bannerImg1Ref.current, {
        width: adaptSize(880),
        height: adaptSize(880),
        left: adaptSize(0),
        top: adaptSize(0),
        x: 0,
        opacity: 1,
        duration: 0.5,
        ease: "none",
        force3D: true,
      }, 0.2);

      tl.to(bannerImg2Ref.current, {
        left: adaptSize(0),
        top: adaptSize(0),
        width: adaptSize(880),
        height: adaptSize(880),
        opacity: 0,
        duration: 0.5,
        ease: "none",
        force3D: true,
      }, 0);

      tl.to(leftRef.current, {
        opacity: 1,
        duration: 0.2,
        ease: "none",
        force3D: true,
      }, 0.7);

      tl.to(rightRef.current, {
        opacity: 1,
        duration: 0.2,
        ease: "none",
        force3D: true,
      }, 1);

      // ==================== 二屏轮播切换动画 ====================
      const tl2 = gsap.timeline({
        scrollTrigger: {
          trigger: secondSectionRef.current,
          start: "top top",
          end: "+=500%",
          scrub: true,
          pin: true,
        },
      });

      const bannerImgs = [
        bannerImg1Ref.current,
        bannerImg2Ref.current,
        bannerImg3Ref.current,
        bannerImg4Ref.current,
        bannerImg5Ref.current,
        bannerImg6Ref.current,
      ];

      bannerImgs.forEach(img => {
        if (img) img.style.willChange = 'transform, opacity, width, height';
      });

      const rightTextRefs: any[] = [rightRef, right2Ref, right3Ref];

      tl2.eventCallback("onUpdate", () => {
        const progress = tl2.progress();
        const totalDuration = 5;
        const t = progress * totalDuration;

        rightTextRefs.forEach((ref) => {
          if (ref.current) gsap.set(ref.current, { opacity: 0 });
        });

        if (t < 1) {
          if (rightRef.current) gsap.set(rightRef.current, { opacity: 1 });
        } else if (t >= 1 && t < 3) {
          if (bannerImg2Ref.current && right2Ref.current) {
            const currentWidth = gsap.getProperty(bannerImg2Ref.current, "width") as number;
            const startWidth = adaptSize(500) as number;
            const endWidth = adaptSize(160) as number;

            let scaleProgress = 1 - (currentWidth - endWidth) / (startWidth - endWidth);
            scaleProgress = Math.max(0, Math.min(1, scaleProgress));
            gsap.set(right2Ref.current, { opacity: scaleProgress });
          }
        } else if (t >= 3 && t < 4) {
          if (bannerImg4Ref.current && right3Ref.current) {
            const currentWidth = gsap.getProperty(bannerImg4Ref.current, "width") as number;
            const startWidth = adaptSize(500) as number;
            const endWidth = adaptSize(160) as number;

            let scaleProgress = 1 - (currentWidth - endWidth) / (startWidth - endWidth);
            scaleProgress = Math.max(0, Math.min(1, scaleProgress));
            gsap.set(right3Ref.current, { opacity: scaleProgress });
          }
        } else if (t >= 4) {
          if (right3Ref.current) gsap.set(right3Ref.current, { opacity: 1 });
        }
      });

      // ========== 第一切换（时间点 0-1） ==========
      tl2.to(bannerImg1Ref.current, { opacity: 0, duration: 1, ease: "none", force3D: true }, 0);
      tl2.to(bannerImg2Ref.current, { opacity: 1, duration: 1, ease: "none", force3D: true }, 0);
      tl2.fromTo([bannerImg3Ref.current],
        { left: adaptSize(1232), top: adaptSize(872), width: adaptSize(8), height: adaptSize(8), opacity: 0, force3D: true },
        { left: adaptSize(920), top: adaptSize(720), width: adaptSize(160), height: adaptSize(160), opacity: 1, duration: 1, ease: "none", force3D: true }, 0);
      tl2.fromTo([bannerImg4Ref.current],
        { left: adaptSize(1232), top: adaptSize(872), width: adaptSize(8), height: adaptSize(8), opacity: 0, force3D: true },
        { left: adaptSize(920), top: adaptSize(720), width: adaptSize(160), height: adaptSize(160), opacity: 0, duration: 1, ease: "none", force3D: true }, 0);

      // ========== 第二切换（时间点 1-2） ==========
      tl2.to(bannerImg2Ref.current, { left: adaptSize(-200), top: 0, width: adaptSize(160), height: adaptSize(160), opacity: 1, duration: 1, ease: "none", force3D: true }, 1);
      tl2.to(bannerImg3Ref.current, { left: 0, top: 0, width: adaptSize(880), height: adaptSize(880), duration: 1, ease: "none", force3D: true }, 1);
      tl2.to(bannerImg4Ref.current, { left: 0, top: 0, width: adaptSize(880), height: adaptSize(880), opacity: 0, duration: 1, ease: "none", force3D: true }, 1);

      // ========== 第三切换（时间点 2-3） ==========
      tl2.to(bannerImg3Ref.current, { opacity: 0, duration: 1, ease: "none", force3D: true }, 2);
      tl2.to(bannerImg4Ref.current, { opacity: 1, duration: 1, ease: "none", force3D: true }, 2);
      tl2.fromTo(bannerImg5Ref.current,
        { left: adaptSize(1232), top: adaptSize(872), width: adaptSize(8), height: adaptSize(8), opacity: 0, force3D: true },
        { left: adaptSize(920), top: adaptSize(720), width: adaptSize(160), height: adaptSize(160), opacity: 1, duration: 1, ease: "none", force3D: true }, 2);
      tl2.fromTo(bannerImg6Ref.current,
        { left: adaptSize(1232), top: adaptSize(872), width: adaptSize(8), height: adaptSize(8), opacity: 0, force3D: true },
        { left: adaptSize(920), top: adaptSize(720), width: adaptSize(160), height: adaptSize(160), opacity: 0, duration: 1, ease: "none", force3D: true }, 2);

      // ========== 第四切换（时间点 3-4） ==========
      tl2.to(bannerImg2Ref.current, { left: adaptSize(-208), top: 0, width: 0, height: 0, opacity: 0, duration: 1, ease: "none", force3D: true }, 3);
      tl2.to(bannerImg4Ref.current, { left: adaptSize(-200), top: 0, width: adaptSize(160), height: adaptSize(160), duration: 1, ease: "none", force3D: true }, 3);
      tl2.to(bannerImg5Ref.current, { left: 0, top: 0, width: adaptSize(880), height: adaptSize(880), duration: 1, ease: "none", force3D: true }, 3);
      tl2.to(bannerImg6Ref.current, { left: 0, top: 0, width: adaptSize(880), height: adaptSize(880), duration: 1, ease: "none", force3D: true }, 3);

      // ========== 第五切换（时间点 4-5） ==========
      tl2.to(bannerImg6Ref.current, { opacity: 1, duration: 1, ease: "none", force3D: true }, 4);

      ScrollTrigger.create({
        trigger: secondSectionRef.current,
        start: "bottom bottom",
        onEnter: () => bannerImgs.forEach(img => { if (img) img.style.willChange = 'auto'; }),
        onLeaveBack: () => bannerImgs.forEach(img => { if (img) img.style.willChange = 'auto'; })
      });

      // ==================== 第三屏动画 ====================
      const t3 = gsap.timeline({
        scrollTrigger: {
          trigger: thirdSectionRef.current,
          start: "top 90%",
          toggleActions: "play none none none",
          once: true
        }
      });

      t3.fromTo(thirdTitleRef.current, { opacity: 0, y: adaptSize(30) }, { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" });
      t3.fromTo(thirdMsgRef.current, { opacity: 0, y: adaptSize(30) }, { opacity: 1, y: 0, duration: 0.5, ease: "power2.out" }, 0.2);
      t3.fromTo(screen31Ref.current, { y: adaptSize(100), opacity: 0, scale: 0.95 }, { y: 0, opacity: 1, scale: 1, duration: 0.8, ease: "power2.out" }, 0.4);
      t3.fromTo(screen32Ref.current, { y: adaptSize(100), opacity: 0, scale: 0.95 }, { y: 0, opacity: 1, scale: 1, duration: 0.8, ease: "power2.out" }, 0.6);
      t3.fromTo([screen31TitleRef.current, screen31MsgRef.current], { opacity: 0, y: adaptSize(20) }, { opacity: 1, y: 0, duration: 0.4, stagger: 0.1, ease: "power2.out" }, 0.8);
      t3.fromTo([screen32TitleRef.current, screen32MsgRef.current], { opacity: 0, y: adaptSize(20) }, { opacity: 1, y: 0, duration: 0.4, stagger: 0.1, ease: "power2.out" }, 1.0);

      // ==================== 第四屏动画 ====================
      const t4 = gsap.timeline({
        scrollTrigger: {
          trigger: fourthSectionRef.current,
          start: "top 80%",
          end: "bottom 20%",
          scrub: false,
          once: true,
          toggleActions: "play none none none"
        }
      });

      t4.fromTo('.a-right-title', { opacity: 0, x: adaptSize(50) }, { opacity: 1, x: 0, duration: 0.6, ease: "power2.out" });
      t4.fromTo('.a-right-msg', { opacity: 0, x: adaptSize(50) }, { opacity: 1, x: 0, duration: 0.6, ease: "power2.out" }, "-=0.4");
      t4.from('.a-right-title-border', { opacity: 0, duration: .6, ease: "power2.out" }, "-=0");

      rightItemsRef.current.forEach((item, index) => {
        if (item) {
          t4.fromTo(item, { y: adaptSize(300), opacity: 0 }, { y: 0, opacity: 1, duration: .8, ease: "power2.out" }, `-=${0.3 - index * 0.05}`);
        }
      });

      // ==================== 呼吸灯动画 ====================
      const masterBreath = gsap.timeline({
        repeat: -1, yoyo: true, defaults: { duration: 1, ease: "power1.inOut" }
      });
      masterBreath.to('.bottom-border-1', { opacity: 0 }, 'breath')
        .to('.bottom-border-2', { opacity: 0.1 }, '<')
        .to('.bottom-border-3', { opacity: 0.3 }, '<');
      masterBreath.to('.bottom-center-g2', { opacity: 0.1 }, 'breath')
        .to('.bottom-center-g3', { opacity: 0.1 }, '>')
        .to('.bottom-center-g4', { opacity: 0.1 }, '>')
        .to('.bottom-center-g5', { opacity: 0.1 }, '>')
        .to('.bottom-center-g6', { opacity: 0.1 }, '>');

      // 注意：第五屏已经改用纯CSS动画(Keyframes)实现无缝轮播，此处已移除旧的GSAP绑定代码以防冲突。
    }, containerRef);

    return () => {
      gsap.ticker.remove(onTick);
      ctx.revert();
    };
  }, [getAllBannerImgRefs, updateBannerSrc]);

  return (
    <div ref={containerRef} className="smart-travel-page responsive-scale">
      {/* Banner 区域 */}
      <div ref={bannerRef} className="intelli-corp-banner">
        <img src={smartTravelBanner} alt="banner" className="corp-banner-img" />
        <div className="banner-content">
          <h1>面向未来·全新出行</h1>
          <p>让驾驶 更智能</p>
          <img src={mouse} alt="" className="mouse" />
        </div>
      </div>

      <div ref={secondSectionRef} className="scroll-second" id="zhinengzuocang">
        <img ref={secondImgTitleRef} src={intelligentCockpit} className="intell-img" />
        <div className="banner-box">
          <div ref={leftRef} className="left">
            <p className="b-title">智能座舱</p>
            <p className="b-msg">构建沉浸式智能座舱空间打造融合AI语音视觉互联生态，提供更愉悦的驾乘体验</p>
          </div>
          <div className="banner-img">
            <img ref={bannerImg1Ref} src={banner1Little} style={{ opacity: 0 }} />
            <img ref={bannerImg2Ref} src={banner2Little} style={{ opacity: 0 }} />
            <img ref={bannerImg3Ref} src={banner3Little} style={{ opacity: 0 }} />
            <img ref={bannerImg4Ref} src={banner4Little} style={{ opacity: 0 }} />
            <img ref={bannerImg5Ref} src={banner5Little} style={{ opacity: 0 }} />
            <img ref={bannerImg6Ref} src={banner6Little} style={{ opacity: 0 }} />
          </div>
          <div className="right">
            <div className="r-box" ref={rightRef}>
              <p className="b-title">车载OS</p>
              <p className="b-msg">智能座舱系统深度迭代与优化多芯片架构兼容<br />与性能调优</p>
            </div>
            <div className="r-box" ref={right2Ref}>
              <p className="b-title">智能语音</p>
              <p className="b-msg">大数据对话配置与策略优化<br />本地生活智能体，语音指令"生活需求"</p>
            </div>
            <div className="r-box" ref={right3Ref}>
              <p className="b-title">地图导航</p>
              <p className="b-msg">车载导航定制开发<br />多车型适配等</p>
            </div>
          </div>
        </div>
      </div>

      {/* 第三屏 */}
      <div ref={thirdSectionRef} className="scroll-third" id="zhinengjiashi">
        <div ref={thirdTitleRef} className="third-title">智能驾驶</div>
        <div ref={thirdMsgRef} className="third-msg">
          融合感知与决策技术，赋予车辆环境理解与智能驾驶能力提升驾驶体验，聚焦安全、减负、增效3大司机核心利益
        </div>
        <div className="img-box">
          <div ref={screen31Ref} className="img-item">
            <img src={screen31} alt="仿真驾驶背景图片" />
            <div ref={screen31TitleRef} className="screen3-img-title">仿真驾驶</div>
            <div ref={screen31MsgRef} className="screen3-img-msg">
              模拟真实道路环境（如交通流、天气、光照等）<br />
              构建虚拟驾驶场景，用于测试自动驾驶算法的功能、安全性
            </div>
          </div>
          <div ref={screen32Ref} className="img-item">
            <img src={screen32} alt="数据标注" />
            <div ref={screen32TitleRef} className="screen3-img-title">数据标注</div>
            <div ref={screen32MsgRef} className="screen3-img-msg">
              AI训练的"基石"。对原始数据（图像、语音、点云等）进行分类、标记和注释<br />
              生成结构化数据集。标签化提升模型智能
            </div>
          </div>
        </div>
      </div>

      {/* 第四屏 */}
      <div ref={fourthSectionRef} className="scroll-fourth" id="hexinyoushi">
        <div className="animation-left">
          <img src={bottomBorder} alt="" className="bottom-border-1" />
          <img src={bottomBorder} alt="" className="bottom-border-2" />
          <img src={bottomBorder} alt="" className="bottom-border-3" />
          <div className="bottom-center-g6"></div>
          <div className="bottom-center-g5"></div>
          <div className="bottom-center-g4"></div>
          <div className="bottom-center-g3"></div>
          <div className="bottom-center-g2"></div>
          <div className="bottom-center-g1"></div>
          <div className="bottom-center-hexagon"></div>
          <div className="border-center-line"></div>
        </div>
        <div className="animation-right">
          <div className="a-right-title">核心优势</div>
          <div className="a-right-msg">全面的工程经验 / 交付更快 / 效率更高</div>
          <div className="a-right-title-border"></div>
          <div className="r-bottom">
            <div ref={el => { rightItemsRef.current[0] = el }} className="r-item">
              <div className="r-i-head">
                <div className="r-i-h-title">
                  <div className="r-i-h-t-text">全面专业人才储备</div>
                  <div className="r-i-h-t-square"></div>
                </div>
                <div className="r-i-h-msg">导航&车机系统成员背景</div>
              </div>
              <div className="r-i-num">
                <div className="n-left">
                  <div className="n-n-left">
                    <div className="num">10</div>
                    <div className="unit">年</div>
                  </div>
                  <div className="hao">+</div>
                </div>
                <div className="n-right">核心成员</div>
              </div>
              <div className="r-i-num">
                <div className="n-left">
                  <div className="n-n-left">
                    <div className="num">5</div>
                    <div className="unit">年</div>
                  </div>
                  <div className="hao">+</div>
                </div>
                <div className="n-right">主力成员</div>
              </div>
            </div>
            <div ref={el => { rightItemsRef.current[1] = el }} className="r-item">
              <div className="r-i-head">
                <div className="r-i-h-title">
                  <div className="r-i-h-t-text">扎实的车载测试经验</div>
                  <div className="r-i-h-t-square blue"></div>
                </div>
              </div>
              <div className="r-i-num">
                <div className="n-left">
                  <div className="n-n-left">
                    <div className="num">10000</div>
                    <div className="hao end-hao">+</div>
                  </div>
                </div>
                <div className="n-right">测试用例</div>
              </div>
              <div className="r-i-num">
                <div className="n-left">
                  <div className="n-n-left">
                    <div className="num">1000</div>
                    <div className="hao end-hao">+</div>
                  </div>
                </div>
                <div className="n-right">导航路测用例</div>
              </div>
            </div>
            <div ref={el => { rightItemsRef.current[2] = el }} className="r-item">
              <div className="r-i-head">
                <div className="r-i-h-title">
                  <div className="r-i-h-t-text">完善质量保障体系</div>
                  <div className="r-i-h-t-square"></div>
                </div>
                <div className="r-i-h-msg">承袭阿里质检体系，统一标准流程、持续优化，已斩获多项国际权体系认证</div>
              </div>
              <div className="r-i-num">
                <div className="n-info">ASPICE Level 2</div>
              </div>
              <div className="r-i-num">
                <div className="n-info">CMMI Level 3</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 第五屏: 合作伙伴 CSS无缝轮播 */}
      <div ref={fifthSectionRef} className="scroll-fifth" id="hezuohuoban">
        <div className="title-box">
          <div className="tb-title">合作伙伴</div>
        </div>

        <div className="merchant-box">

          {/* 第一行（前10个） */}
          <div className="marquee-row">
            {/* 真实数据容器 */}
            <div className="marquee-scroll">
              {row1Merchants.map((item, index) => (
                <div key={`r1-${index}`} className="mb-item">
                  <img src={item.src} alt={item.alt} className={item.className} />
                </div>
              ))}
            </div>
            {/* 克隆容器：用于实现无缝衔接 */}
            <div className="marquee-scroll" aria-hidden="true">
              {row1Merchants.map((item, index) => (
                <div key={`r1-clone-${index}`} className="mb-item">
                  <img src={item.src} alt={item.alt} className={item.className} />
                </div>
              ))}
            </div>
          </div>

          {/* 第二行（后11个） */}
          <div className="marquee-row">
            <div className="marquee-scroll">
              {row2Merchants.map((item, index) => (
                <div key={`r2-${index}`} className="mb-item">
                  <img src={item.src} alt={item.alt} className={item.className} />
                </div>
              ))}
            </div>
            <div className="marquee-scroll" aria-hidden="true">
              {row2Merchants.map((item, index) => (
                <div key={`r2-clone-${index}`} className="mb-item">
                  <img src={item.src} alt={item.alt} className={item.className} />
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SmartTravel;
